<template>
    <div class="body">
  
      <link :href="dynamicCssPath" rel="stylesheet" type="text/css">
      <transition name="el-zoom-in-bottom">
        <div id="content">
          <div middle>
              <navD @child-event="showChannelNav"></navD>
  
              <transition name="el-zoom-in-center">
                <child-performanceTabc ref="childPerformanceTabc" v-show="activeTab=='performanceTab'?true:false" ></child-performanceTabc>
              </transition>

              <transition name="el-zoom-in-center">
                <child-changeShaftTabc ref="childChangeShaftTabc" v-show="activeTab=='changeShaftTab'?true:false" ></child-changeShaftTabc>
              </transition>
  
              <transition name="el-zoom-in-center">
                <child-journeyTabc ref="childJourneyTabc" v-show="activeTab=='journeyTab'?true:false" ></child-journeyTabc>
              </transition>
  

              <transition name="el-zoom-in-center">
                <child-advancedTabc ref="childAdvancedTabc" v-show="activeTab=='advancedTab'?true:false" ></child-advancedTabc>
              </transition>


              <transition name="el-zoom-in-center">
                <child-fnTabc ref="childFnTabc" v-show="activeTab=='fnTab'?true:false" ></child-fnTabc>
              </transition>

              <transition name="el-zoom-in-center">
                <child-buttonTabc ref="childButtonTabc" v-show="activeTab=='buttonTab'?true:false" ></child-buttonTabc>
              </transition>
  
              <transition name="el-zoom-in-center">
                <child-ligthTabc ref="childLigthTabc" v-show="activeTab=='ligthTab'?true:false" ></child-ligthTabc>
              </transition>
              
              <transition name="el-zoom-in-center">
                <child-otherTabc ref="childOtherTabc" v-show="activeTab=='otherTab'?true:false" ></child-otherTabc>
              </transition>

              <transition name="el-zoom-in-center">
                <child-aboutTabc ref="childAboutTabc" v-show="activeTab=='aboutTab'?true:false" ></child-aboutTabc>
              </transition>

              <transition name="el-zoom-in-center">
                <child-shareGameTabc ref="childShareGameTabc" v-show="activeTab=='shareGameTab'?true:false" ></child-shareGameTabc>
              </transition>
  
          </div>
        </div>
      </transition>
      
      <child-homePagec ref="childhomePagec" @child-event="load"></child-homePagec>
 
    </div>
</template>
  
<script>
import $ from 'jquery'
import navD from './components/nav.vue'
import performanceTabC from './components/performanceTab.vue'
import changeShaftTabC from './components/changeShaftTab.vue'
import journeyTabC from './components/journeyTab.vue'
import advancedTabC from './components/advancedTab.vue'

import fnTabC from './components/fnTab.vue'
import buttonTabC from './components/buttonTab.vue'
import ligthTabC from './components/ligthTab.vue'
import otherTabC from './components/otherTab.vue'
import aboutTabC from './components/aboutTab.vue'

import homePageC from './components/homePage.vue'
import shareGameTabC from './components/shareGameTab.vue'


export default {
  name: 'app',
  components: { 
    navD,
    'child-performanceTabc':performanceTabC,
    'child-changeShaftTabc':changeShaftTabC,
    'child-journeyTabc':journeyTabC,
    'child-advancedTabc':advancedTabC,

    'child-fnTabc':fnTabC,
    'child-buttonTabc':buttonTabC,
    'child-ligthTabc':ligthTabC,
    'child-otherTabc':otherTabC,
    'child-aboutTabc':aboutTabC,

    'child-shareGameTabc':shareGameTabC,
    'child-homePagec':homePageC
  },
  data() {
    return {
      ThemeConf:null,
      activeTab: "performanceTab",
      commonHead:false,
      loading:-1,
      primaryBgColor: 'var(--primary-bg-color)'
    }

  },
  mounted() 
  {
    // this.warn();
    //点击连接HID设备
    window.connectDrive = function()
    {
      $("#drive_list li:first").trigger("click");
    }
  },
  methods: 
  {
    //获取主题LOGO
    getLogoPath()
    {
      let imgUrl = require("../../" + process.env.VUE_APP_THEMENAME + "/asserts/image/loading.png");   
      return imgUrl;
    },
    //获取
    getCurAxis(ThemeConf)
    {
        let axis =  localStorage.getItem('axis');
        if(axis)
        {
            axis = JSON.parse(axis);
            ThemeConf.axisSet.brand = axis.brand;
            ThemeConf.axisSet.model = axis.model;

            ThemeConf.axisSet.RT = axis.RT;
            ThemeConf.axisSet.maxHigth = axis.maxHigth;
        }

        this.ThemeConf = ThemeConf;

        return ThemeConf;
    },
    //实时设置设备操作对象、更新数据
    setDeviceObj(HIDDeviceObj,ThemeConf)
    {
            ThemeConf = this.getCurAxis(ThemeConf);

      const ChildHomePageC = this.$refs.childhomePagec;
            ChildHomePageC.ThemeConf = ThemeConf;
            ChildHomePageC.curHIDDeviceObj = HIDDeviceObj;
            ChildHomePageC.init();
            ChildHomePageC.updateList();

      const ChildPerformanceTabC = this.$refs.childPerformanceTabc;
            ChildPerformanceTabC.HIDDeviceObj = HIDDeviceObj;
            ChildPerformanceTabC.ThemeConf = ThemeConf;
            ChildPerformanceTabC.initData();
            ChildPerformanceTabC.init();

      const ChildChangeShaftTabC = this.$refs.childChangeShaftTabc;
            ChildChangeShaftTabC.HIDDeviceObj = HIDDeviceObj;
            ChildChangeShaftTabC.ThemeConf = ThemeConf;
            ChildChangeShaftTabC.initData();
            ChildChangeShaftTabC.init();

      const ChildJourneyTabC = this.$refs.childJourneyTabc;
            ChildJourneyTabC.HIDDeviceObj = HIDDeviceObj;
            ChildJourneyTabC.ThemeConf = ThemeConf;
            ChildJourneyTabC.initData();
            ChildJourneyTabC.init();

      const ChildAdvancedTabC = this.$refs.childAdvancedTabc;
            ChildAdvancedTabC.HIDDeviceObj = HIDDeviceObj;
            ChildAdvancedTabC.ThemeConf = ThemeConf;
            ChildAdvancedTabC.init();


      const ChildFnTabC = this.$refs.childFnTabc;
            ChildFnTabC.HIDDeviceObj = HIDDeviceObj;
            ChildFnTabC.init();

      const ChildButtonTabC = this.$refs.childButtonTabc;
            ChildButtonTabC.HIDDeviceObj = HIDDeviceObj;
            ChildButtonTabC.init();


      const ChildLigthTabC = this.$refs.childLigthTabc;
            ChildLigthTabC.HIDDeviceObj = HIDDeviceObj;
            ChildLigthTabC.init();

      const ChildOtherTabC = this.$refs.childOtherTabc;

            ChildOtherTabC.ThemeConf = ThemeConf;
            ChildOtherTabC.HIDDeviceObj = HIDDeviceObj;
            ChildOtherTabC.init();

      const ChildAboutTabC = this.$refs.childAboutTabc;

            ChildAboutTabC.ThemeConf = ThemeConf;
            ChildAboutTabC.HIDDeviceObj = HIDDeviceObj;
            ChildAboutTabC.init();

      const ChildShareGameTabC = this.$refs.childShareGameTabc;
            ChildShareGameTabC.HIDDeviceObj = HIDDeviceObj;
            ChildShareGameTabC.init();
    },
    //实时读取数据要刷新的页面
    refreshData(HIDDeviceObj)
    {
      switch(this.activeTab)
      {
        case "performanceTab":
        {
          const ChildPerformanceTabC = this.$refs.childPerformanceTabc;
                ChildPerformanceTabC.HIDDeviceObj = HIDDeviceObj;
                ChildPerformanceTabC.init();
        }break;
        case "changeShaftTab":
        {
          const ChildChangeShaftTabC = this.$refs.childChangeShaftTabc;
                ChildChangeShaftTabC.HIDDeviceObj = HIDDeviceObj;
                ChildChangeShaftTabC.init();
        }break;
        case "journeyTab":
        {
          const ChildJourneyTabC = this.$refs.childJourneyTabc;
            ChildJourneyTabC.HIDDeviceObj = HIDDeviceObj;
            ChildJourneyTabC.init();
        }break;
        case "advancedTab":
        {
          const ChildAdvancedTabC = this.$refs.childAdvancedTabc;
            ChildAdvancedTabC.HIDDeviceObj = HIDDeviceObj;
            ChildAdvancedTabC.init();
        }break;
        case "fnTab":
        {
          const ChildFnTabC = this.$refs.childFnTabc;
                ChildFnTabC.HIDDeviceObj = HIDDeviceObj;
                ChildFnTabC.init();
        }break;
        case "buttonTab":
        {
          const ChildButtonTabC = this.$refs.childButtonTabc;
                ChildButtonTabC.HIDDeviceObj = HIDDeviceObj;
                ChildButtonTabC.init();
        }break;
        case "ligthTab":
        {
          const ChildLigthTabC = this.$refs.childLigthTabc;
            ChildLigthTabC.HIDDeviceObj = HIDDeviceObj;
            ChildLigthTabC.init();
        }break;
        case "otherTab":
        {
          const ChildOtherTabC = this.$refs.childOtherTabc;
            ChildOtherTabC.HIDDeviceObj = HIDDeviceObj;
            ChildOtherTabC.init();
        }break;
        case "aboutTab":
        {
          const ChildAboutTabC = this.$refs.childAboutTabc;
                ChildAboutTabC.HIDDeviceObj = HIDDeviceObj;
                ChildAboutTabC.init();
        }break;
      }
    },
    showChannelNav(name)
    {
        //异常处理
        if(this.activeTab == "performanceTab")
        {
          const ChildPerformanceTabC = this.$refs.childPerformanceTabc;
                ChildPerformanceTabC.stopJourney();
        }
        else if(this.activeTab == "journeyTab")
        {
          const ChildJourneyTabC = this.$refs.childJourneyTabc;
                ChildJourneyTabC.stopCalibrate();
        }
        else if(this.activeTab == "changeShaftTab")
        {
          const ChildChangeShaftTabC = this.$refs.childChangeShaftTabc;
                ChildChangeShaftTabC.stopJourney();
        }
        
        //处理本页面要加载的数据
        this.activeTab = name;
        switch(this.activeTab)
        {
          case "performanceTab":
          {
            const ChildPerformanceTabC = this.$refs.childPerformanceTabc;
                  ChildPerformanceTabC.readJourneyCustom();
                  
          }break;
          case "changeShaftTab":
          {
              const ChildChangeShaftTabC = this.$refs.childChangeShaftTabc;
                    // ChildChangeShaftTabC.readJourneyCustom();
          }break;
          case "journeyTab":
          {

          }break;
          case "advancedTab":
          {
            const ChildAdvancedTabC = this.$refs.childAdvancedTabc;
                  ChildAdvancedTabC.readLayout8Custom();
          }break;
          case "fnTab":
          {
            const ChildFnTabC = this.$refs.childFnTabc;
                  ChildFnTabC.readLayout1Custom();
          }break;
          case "buttonTab":
          {
            const ChildButtonTabC = this.$refs.childButtonTabc;
                  ChildButtonTabC.readLayout0Custom();
          }break;
          case "ligthTab":
          {
            const ChildLigthTabC = this.$refs.childLigthTabc;
                  ChildLigthTabC.readLigth();

          }break;
          case "otherTab":
          {
            const ChildOtherTabC = this.$refs.childOtherTabc;
                  ChildOtherTabC.readKeyboardParameter();
          }break;
        }
        
    },
    warn()
    {
        if(this.loading != -1)
        {
          this.loading.close();
        }

        this.loading = this.$loading({
          lock: true,
          text: this.$i18n.t("msg.loadingConnect"),
          spinner: 'el-icon-loading',
          background: '#000',
          // target:document.querySelector("#content")
        });

        // 创建DOM元素来包含文本和链接
        const div = document.createElement('div');
        div.innerHTML = this.$i18n.t("msg.loadingConnectWarn") 
        + "<a style='color:#dcdcdcf2;text-decoration: underline;' onclick='connectDrive()'>"+ this.$i18n.t("msg.loadingConnectWarn1") +"</a>" + "&nbsp; | &nbsp;"
        + "<a style='color:#dcdcdcf2;text-decoration: underline;' href='javascript:window.location.reload();'>"+ this.$i18n.t("msg.loadingConnectWarn2") +"...</a>";
  
        // 获取Loading中的文本元素
        const textElement = this.loading.$el.querySelector('.el-loading-text');
  
        // 清空原有文本并添加新的DOM元素
        if (textElement) 
        {
          textElement.innerHTML = '';
          textElement.appendChild(div);
        }



    },
    load() 
    {
        if(this.loading != -1)
        {
          this.loading.close();
        }

        // const style = getComputedStyle(document.documentElement);
        // const cssVariableValue = style.getPropertyValue('--primary-bg-color');
        // console.log(cssVariableValue); // 输出CSS变量的值

        this.loading = this.$loading({
          lock: true,
          text: this.$i18n.t("msg.successfulCertification"),
          spinner: 'el-icon-loading',
          background: this.ThemeConf.loadBgColor,
          // target:document.querySelector("#content")
        });

        // 获取Loading中的ICON
        const loadElement = this.loading.$el.querySelector('.el-loading-spinner');
        const iconElement = this.loading.$el.querySelector('.el-icon-loading');//
        // 清空原有文本并添加新的DOM元素
        iconElement.remove();

        const img = document.createElement('img');
        img.src= this.getLogoPath();
        img.classList.add("logo");
        loadElement.prepend(img);

        setTimeout(()=>{this.loading.close();},2000);
    }
  },
  computed: 
  {
      dynamicCssPath: function() 
      {
          if(this.activeTab == 'performanceTab')
          {
            return require("./asserts/css/performanceTab.css"); 
          }
          if(this.activeTab == 'changeShaftTab')
          {
            return require("./asserts/css/changeShaftTab.css"); 
          }
          else if(this.activeTab == 'journeyTab')
          {
            return require("./asserts/css/journeyTab.css");
          }
          else if(this.activeTab == 'buttonTab')
          {
            return require("./asserts/css/buttonTab.css");
          }
          else if(this.activeTab == 'fnTab')
          {
            return require("./asserts/css/fnTab.css");
          }
          else if(this.activeTab == 'advancedTab')
          {
            return require("./asserts/css/advancedTab.css");
          }
          else if(this.activeTab == 'ligthTab')
          {
            return require("./asserts/css/ligthTab.css");
          }
          else if(this.activeTab == 'otherTab')
          {
            return require("./asserts/css/otherTab.css");
          }
          else if(this.activeTab == 'shareGameTab')
          {
            return require("./asserts/css/shareGameTab.css");
          }

          return require("./asserts/css/performanceTab.css");
      
      }
  }
}
</script>